var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2Wind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 7.46V66h4V35.49l34-7.94V18L25 7.46zm9 22.77l-5 1.17V12.71l5 1.39v16.13zm12-2.8l-6 1.4V15.76l6 1.66v10.01zm13-3L52 26v-6.91L59 21v3.43z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B2_Wind.845a82a5.svg";
export { SvgB2Wind as ReactComponent };